import type {
  GetPdfFitTypeProps,
  GetPdfPageSizeProps,
  PdfViewerFitType,
} from "./pdf-viewer.type";
import type { DocumentProps, PageProps } from "react-pdf";

export const getPdfFitType = ({
  fitToWrapper,
  wrapperSize,
  pdfPageRatio,
}: GetPdfFitTypeProps): PdfViewerFitType => {
  if (!fitToWrapper || !wrapperSize || !pdfPageRatio) return null;

  const wrapperRatio = wrapperSize.width / wrapperSize.height;

  return wrapperRatio > pdfPageRatio ? "height" : "width";
};

export const getPdfPageSize = ({
  fitType,
  wrapperSize,
}: GetPdfPageSizeProps): Pick<PageProps, "width" | "height"> => {
  if (fitType === null) {
    return {
      width: wrapperSize?.width,
      height: undefined,
    };
  }

  if (fitType === "width") {
    return {
      width: wrapperSize?.width,
      height: undefined,
    };
  }

  return {
    width: undefined,
    height: wrapperSize?.height,
  };
};

export const getPdfDocumentOptions = (): DocumentProps["options"] => {
  const getWasmUrl = () => {
    if (typeof document !== "undefined") {
      // Use document.baseURI to honor any non-root base paths when constructing wasm URL.
      return new URL("/wasm/", document.baseURI).href;
    }

    return "/wasm/";
  };

  return {
    wasmUrl: getWasmUrl(),
  };
};
